// Phone number validation utility for InfluenceHub MVP
// Normalizes phone numbers by stripping formatting and validates digit count

/**
 * Normalizes a phone number by removing all non-digit characters
 * @param {string} phone - The phone number string (may include formatting)
 * @returns {string} - Digits-only phone number
 */
export function normalizePhone(phone) {
  if (!phone) return '';
  return phone.replace(/[^0-9]/g, '');
}

/**
 * Validates a phone number
 * @param {string} phone - The phone number string (may include formatting)
 * @returns {{valid: boolean, error?: string}} - Validation result
 */
export function validatePhone(phone) {
  if (!phone || !phone.trim()) {
    return {
      valid: false,
      error: 'Phone number is required'
    };
  }

  const digits = normalizePhone(phone);
  
  if (digits.length < 10) {
    return {
      valid: false,
      error: 'Please enter a valid phone number (10–15 digits).'
    };
  }
  
  if (digits.length > 15) {
    return {
      valid: false,
      error: 'Please enter a valid phone number (10–15 digits).'
    };
  }

  return {
    valid: true
  };
}

